import React from 'react'
import styles from './ProjectsPanel.module.scss'
import { UserProjectsTable } from './UserProjectsTable/UserProjectsTable'
import { AdminHeader } from './AdminHeader/AdminHeader'
import { useProjectsPanel } from './hooks'

export const ProjectsPanel = ({ pk, id, selectedUser, setUser }) => {
  const {
    state: { department, search },
    handlers: { setSearch },
  } = useProjectsPanel({ id })

  return (
    <>
      <div className={styles.departmentsPanel}>
        <AdminHeader
          selectedUser={selectedUser}
          department={department}
          setUser={setUser}
          search={search}
          setSearch={setSearch}
        />
        {selectedUser ? (
          <UserProjectsTable
            selectedUser={selectedUser}
            department={department}
            search={search}
            id={id}
          />
        ) : null}
      </div>
    </>
  )
}
